<template>
    <div>
        <v-row no-gutters align="center">
            <v-col cols="12" md="6">
                <modal-cadu close :width="620" v-model="valueData">
                    <div slot="all" class="py-6 px-6">
                        <div slot="body">
                            <v-row v-if="!$vuetify.breakpoint.xs" class="align-center justify-center ">
                                <v-col cols="auto" class="mb-4">
                                    <div class="font-secundaria font-weight-bold title fontColor--text">
                                        Deseja atualizar os demais dados desta Unimed?
                                    </div>
                                </v-col>
                                <v-row class="align-center justify-space-around">
                                    <v-col cols="auto">
                                        <button-cadu
                                            text="NÃO"
                                            @click="$emit('closeModal')"
                                            outline
                                        />
                                    </v-col>
                                    <v-col cols="auto">
                                        <button-cadu
                                            text="SIM"
                                            @click="$emit('editarDados')"
                                            :backColor="$vuetify.theme.themes.light.primary1"
                                        />
                                    </v-col>
                                </v-row>
                            </v-row>
                        </div>
                    </div>
                </modal-cadu>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ModalMixin from '@/Mixins/ModalMixin'
export default {
  mixins: [ModalMixin]
}
</script>
